import { createSelector } from 'reselect';

export default createSelector(
  [state => state.auth.currentOrganization],
  organization => organization
);
